import GameLauncher from './components/GameLauncher.tsx';
import './App.css';

function App() {
  return (
    <div className="app">
      <header className="app-header">
        <div className="brand">
          {/* <span className="brand-logo">F</span>
          <div className="brand-text">
            <span className="brand-name">FlexSoft</span>
            <span className="brand-sub">Game Platform</span>
          </div> */}
          <span className="brand-name">Dynamic platform</span>
        </div>
      </header>
      <GameLauncher />
    </div>
  );
}

export default App;
